<template>
  <div id="artists">
    <FadeLoader />
    <b-container class="artists-nav"
      ><img
        id="cubs-logo"
        :src="require('@/assets/images/artistshome/cubs-logo.png')"
      />
      <div>
        <svg width="135" height="31" viewBox="0 0 135 31" xmlns="http://www.w3.org/2000/svg" v-bind:class="'respectLogo'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="none" fill-rule="evenodd"><path d="M101.35 29.522c-7.803 0-14.151-6.349-14.151-14.151 0-7.801 6.348-14.149 14.151-14.149 5.146 0 9.659 2.762 12.135 6.88l-4.095 2.532a9.338 9.338 0 00-8.04-4.596c-5.147 0-9.336 4.187-9.336 9.333 0 5.148 4.189 9.336 9.336 9.336a9.338 9.338 0 008.04-4.598l4.095 2.532c-2.476 4.118-6.989 6.881-12.135 6.881zm7.542-11.158a8.114 8.114 0 01-7.542 5.12 8.112 8.112 0 110-16.225 8.113 8.113 0 017.542 5.12l6.225-3.849C112.6 3.474 107.382 0 101.35 0c-8.49 0-15.372 6.882-15.372 15.371 0 8.49 6.881 15.372 15.372 15.372 6.032 0 11.25-3.474 13.767-8.529l-6.225-3.85z" fill="#FFF"/><path fill="#00306B" d="M114.641 25.062h.358v.975h.242v-.975h.358v-.212h-.958zM116.806 24.85l-.288.776h-.006l-.275-.776h-.421v1.187h.242v-.944h.005l.333.944h.236l.343-.944h.005v.944h.242V24.85z"/><path d="M109.39 20.109a9.338 9.338 0 01-8.04 4.597c-5.147 0-9.335-4.188-9.335-9.335 0-5.146 4.188-9.334 9.335-9.334a9.338 9.338 0 018.04 4.598l4.095-2.532c-2.476-4.12-6.989-6.881-12.135-6.881-7.803 0-14.151 6.347-14.151 14.15 0 7.801 6.348 14.15 14.151 14.15 5.146 0 9.659-2.762 12.135-6.88l-4.095-2.533z" fill="#CE0E2D"/><path d="M6.387 10.08h-3.1v4.446h3.1c1.443 0 2.389-.922 2.389-2.223 0-1.301-.946-2.224-2.39-2.224zM8.94 23.987L5.653 17.27H3.288v6.718H0V7.146h6.6c3.43 0 5.464 2.342 5.464 5.157 0 2.366-1.443 3.832-3.075 4.423l3.76 7.262H8.942zM17.833 23.988V7.146h11.093v2.933h-7.805v3.95h6.646v2.934h-6.646v4.092h7.805v2.933zM39.142 24.13c-2.554 0-4.494-.544-6.15-2.224l2.13-2.129c1.063 1.065 2.507 1.42 4.068 1.42 1.939 0 2.98-.734 2.98-2.082 0-.592-.165-1.088-.52-1.42-.332-.307-.71-.472-1.49-.59l-2.035-.284c-1.443-.213-2.507-.663-3.264-1.396-.804-.804-1.206-1.892-1.206-3.311 0-3.005 2.223-5.11 5.866-5.11 2.318 0 3.997.568 5.44 1.963l-2.081 2.059c-1.065-1.017-2.342-1.16-3.454-1.16-1.75 0-2.601.97-2.601 2.13 0 .425.14.874.496 1.205.331.308.875.569 1.561.663l1.987.284c1.538.213 2.507.639 3.217 1.3.9.852 1.301 2.083 1.301 3.573 0 3.263-2.72 5.109-6.245 5.109M57.212 10.08h-3.076v4.612h3.076c1.49 0 2.436-.923 2.436-2.294 0-1.372-.946-2.319-2.436-2.319m.165 7.57h-3.24v6.339h-3.289V7.146h6.53c3.476 0 5.558 2.39 5.558 5.252 0 2.862-2.082 5.25-5.559 5.25M68.066 23.988V7.146H79.16v2.933h-7.806v3.95H78v2.934h-6.647v4.092h7.806v2.933zM130.433 10.08v13.908h-3.288V10.079h-4.4V7.146h12.088v2.933z" fill="#00306B"/></g></svg>

        <svg width="20" height="10" viewBox="0 0 20 10" xmlns="http://www.w3.org/2000/svg" v-if="!openMenu" v-bind:class="'hamburger-desktop'" v-bind:svg-inline="''" @click="toggleNav()" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="#BCBCBC" fill-rule="evenodd"><path d="M0 0h20v2H0zM0 4h20v2H0zM0 8h20v2H0z"/></g></svg>
        <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" v-else="" v-bind:class="'close-desktop'" v-bind:svg-inline="''" @click="toggleNav()" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="#BCBCBC" fill-rule="evenodd"><path d="M.121 10.243l9.9-9.9 1.414 1.414-9.9 9.9z"/><path d="M1.535.343l9.9 9.9-1.414 1.414-9.9-9.9z"/></g></svg>
      </div>
      <div class="desktopMenu" :class="{ active: openMenu }">
        <b-container class="desktopMenuContainer">
          <a
            href="https://cubs.fanportal-mlb.com/artists"
            v-ePitchTracking="{
              site: 'common',
              category: 'Project Navigation',
              label: 'Home',
            }"
            ><h4>HOME</h4></a
          >
          <a
            href="https://cubs.fanportal-mlb.com/artists/louisdeguzman"
            v-ePitchTracking="{
              site: 'common',
              category: 'Project Navigation',
              label: 'Louis De Guzman',
            }"
            ><h4>Louis De Guzman</h4></a
          >
          <div
            class="menuLink"
            :class="{ active: previousActive }"
            @click="previousActive = !previousActive"
          >
            <h4>2021 Collection</h4>
          </div>
          <div class="previousCollection" :class="{ active: previousActive }">
            <a
              href="https://cubs.fanportal-mlb.com/artists/bhm"
              v-ePitchTracking="{
                site: 'common',
                category: 'Project Navigation',
                label: 'Nikko Washington',
              }"
              ><h4>Nikko Washington</h4></a
            >
            <a
              href="https://cubs.fanportal-mlb.com/artists/whm"
              v-ePitchTracking="{
                site: 'common',
                category: 'Project Navigation',
                label: 'Kate Lynn Lewis',
              }"
              ><h4>Kate Lynn Lewis</h4></a
            >
            <a
              href="https://cubs.fanportal-mlb.com/artists/whm"
              v-ePitchTracking="{
                site: 'common',
                category: 'Project Navigation',
                label: 'Penny Pinch',
              }"
              ><h4>Penny Pinch</h4></a
            >
            <a
              href="https://cubs.fanportal-mlb.com/artists/samkirk"
              v-ePitchTracking="{
                site: 'common',
                category: 'Project Navigation',
                label: 'Sam Kirk',
              }"
              ><h4>Sam Kirk</h4></a
            >
            <a
              href="https://cubs.fanportal-mlb.com/artists/pabloserrano"
              v-ePitchTracking="{
                site: 'common',
                category: 'Project Navigation',
                label: 'Pablo Serrano',
              }"
              ><h4>Pablo Serrano</h4></a
            >
          </div>
        </b-container>
      </div>
    </b-container>
    <b-container class="primary-artist">
      <router-link :to="primaryArtist.slug">
        <img
          class="img-artist-primary"
          :src="primaryArtist.imgPath"
          v-if="global.screenWidth > 768"
        />
        <img
          class="img-artist-primary"
          :src="primaryArtist.mobileImgPath"
          v-else
        />
      </router-link>
      <div class="artist-primary-container">
        <div class="artist-primary-titles">
          <h4>{{ primaryArtist.title }}</h4>
          <span class="text" v-html="primaryArtist.text"></span>
        </div>
        <router-link :to="primaryArtist.slug">
          <div class="button red-button"><span>VIEW ARTWORK</span></div>
        </router-link>
      </div>
      <div class="spacer" />
      <h3>PREVIOUS ARTISTS (2021)</h3>
    </b-container>

    <b-container class="artists-duo">
      <router-link
        :to="artist.slug"
        v-for="(artist, index) in artists"
        :key="index"
        class="artist-card"
      >
        <img class="img-artist" :src="artist.imgPath" />
        <img class="img-signature" :src="artist.logoPath" />
        <h4>{{ artist.title }}</h4>
        <span class="text" v-html="artist.text"></span>
      </router-link>
    </b-container>
  </div>
</template>

<script>
import { mapState } from "vuex";
import FadeLoader from "@/components/global/FadeLoader";

export default {
  name: "Artists",
  components: { FadeLoader },
  data() {
    return {
      openMenu: false,
      previousActive: false,
      primaryArtist: {
        title: "Louis De Guzman",
        text: `Louis De Guzman is an award-winning visual artist and designer who creates artwork that merges his past with his present. To learn more about Louis De Guzman or to view his work, visit: <a href="https://www.louisdeguzman.com" target="_blank">www.louisdeguzman.com</a>.`,
        slug: "/louisdeguzman",
        imgPath: require("@/assets/images/artistshome/deguzman/louis-hero-home.jpg"),
        mobileImgPath: require("@/assets/images/artistshome/deguzman/louis-mobile-background.jpg"),
      },
      artists: [
        {
          title: "Hispanic Heritage Month",
          text: `Pablo Serrano, a Chicago native who resides in Pilsen, is a lifelong artist and cultural worker focused on creating public art and social musical experiences.  He combines muralism, art, education and collaborations with diverse creative partners to create culture with and for the community. To learn more about Pablo Serrano, visit: <a href="https://pabloserranoart.com/" target="_blank">www.pabloserranoart.com</a>.`,
          slug: "/pabloserrano",
          imgPath: require("@/assets/images/artistshome/pablo/pablo-hero.jpg"),
          mobileImgPath: require("@/assets/images/artistshome/pablo/pablo-mobile-background.jpg"),
        },
        {
          title: "Pride",
          text: `Sam Kirk is a multidisciplinary artist and biracial, queer woman whose artwork celebrates differences to enact change. Including vivid and powerful images of women, members of the LGBTQ community, and those who have historically been underrepresented are celebrated through her art. To learn more about Sam Kirk, visit: <a href="http://iamsamkirk.com/" target="_blank">iamsamkirk.com</a>.`,
          slug: "/samkirk",
          imgPath: require("@/assets/images/artistshome/sam/Sam-kirk-hero.jpg"),
          logoPath: require("@/assets/images/artistshome/sam/Sam-Kirk.png"),
          mobileImgPath: require("@/assets/images/artistshome/sam/sam-kirk-mobile-background.jpg"),
        },
        {
          title: "Mental Health",
          text: `Efdot is a visual artist and community builder known for his iconic Blob character and abstract-meets-figurative style which explores the balance between playfulness, sophistication and mischief. To learn more about Efdot, please visit: <a href="https://www.efdotstudio.com" target="_blank">www.efdotstudio.com</a>.`,
          slug: "/efdot",
          imgPath: require("@/assets/images/artistshome/efdot/Efdot-bg-desktop.jpg"),
          logoPath: require("@/assets/images/artistshome/efdot/Efdot-logo.svg"),
          mobileImgPath: require("@/assets/images/artistshome/efdot/Efdot-bg-desktop.jpg"),
        },
        {
          title: "EARTH DAY",
          text: `Penny Pinch, a street artist in Chicago, works entirely with free and found materials, never spending any money on supplies for his artwork. To learn more about Penny Pinch and his work, visit his Instagram: <a href="https://www.instagram.com/_pennypinch_"
            target="_blank"
            style="color: #ce0e2d">@_pennypinch_</a>`,
          imgPath: require("@/assets/images/artistshome/penny-pinch/home-Penny-Pinch.jpg"),
          logoPath: require("@/assets/images/artistshome/penny-pinch/penny-pinch-name-logo.svg"),
          slug: "/pennypinch",
        },
        {
          title: "Women's History",
          text: `Kate Lynn Lewis is a Chicago-based artist focused on large-scale mural installations and illustrative design. To learn more about Kate Lynn Lewis or to view her work, visit <a href="https://www.katelynnlewis.com" target="_blank">www.katelynnlewis.com.</a>`,
          imgPath: require("@/assets/images/galleries/artist-kate/Kate - Slider 01.jpg"),
          logoPath: require("@/assets/images/artistshome/kate/Katelynn-Signature.svg"),
          slug: "/whm",
        },
        {
          title: "Black History",
          text: `Nikko Washington is a Chicago native raised in Hyde Park who excels in a variety of media, including paint, graphic design and screen printing. To learn more about Nikko Washington, visit <a href="https://www.nikkowashington.com" target="_blank">www.nikkowashington.com.</a>`,
          imgPath: require("@/assets/images/galleries/NIKKO/NIKKO-IMG-01.jpg"),
          logoPath: require("@/assets/images/artistshome/nikko/Nikko-Signature.svg"),
          slug: "/bhm",
        },
      ],
    };
  },
  computed: {
    ...mapState(["global"]),
  },
  methods: {
    toggleNav() {
      const newVal = !this.openMenu;
      this.openMenu = newVal;
      document.documentElement.style.overflow = !newVal ? "auto" : "hidden";
    },
  },
};
</script>

<style lang="scss" scoped>
#artists {
  width: 100%;
  padding-bottom: 80px;
  .artists-duo {
    margin-top: 1vh;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    @media (max-width: $md) {
      flex-direction: column;
      justify-content: flex-start;
      margin-top: 5vh;
    }
  }
  .primary-artist {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .artist-card {
    width: 490px;
    cursor: pointer;
    outline: none;
    text-decoration: none;
    width: calc(50% - 10px);
    max-width: 100%;
    margin-bottom: 80px;
    @media (max-width: $md) {
      width: 100%;
    }
    .img-artist {
      width: 100%;
      height: auto;
      object-fit: cover;
      transition: all 0.2s ease-in;
      height: 282px;
      width: 545px;
      &:hover {
        transform: scale(1.05);
      }
    }

    .img-signature {
      margin-top: 30px;
      max-height: 47px;
    }
  }
  h4 {
    margin-top: 12px;
    font-family: Poppins-Bold;
    font-size: 16px;
    color: #1a1a1a;
    letter-spacing: 0;
    line-height: 22px;
    text-transform: uppercase;
  }
  h3 {
    margin: 24px 0;
    font-family: Poppins-Bold;
    font-size: 24px;
    color: #1a1a1a;
    letter-spacing: 0;
    line-height: 22px;
    text-transform: uppercase;
    @media (max-width: $md) {
      margin-bottom: 0;
    }
  }
  .text {
    margin-top: 10px;
    font-family: AvenirNext-Regular;
    font-size: 14px;
    color: #3e3e3e;
    line-height: 23px;
  }
  .img-artist-primary {
    width: 100%;
    height: auto;
    margin-bottom: 24px;
    transition: all 0.2s ease-in;

    &:hover {
      transform: scale(1.05);
    }
  }

  .spacer {
    height: 4px;
    // background-color: rgb(234, 234, 234);
    background-color: #eaeaea;
    width: 100%;
    margin: 32px 0;
  }
  .artist-primary-container {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
    width: 100%;

    .text {
      width: 640px;
      max-width: 100%;
    }
    @media (max-width: $lg) {
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      .text {
        margin-bottom: 12px;
      }
    }
  }
  .artist-primary-titles {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    max-width: 100%;
  }
  .artists-nav {
    height: 80px;
    width: 100%;

    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    #cubs-logo {
      width: 46px;
      height: 46px;
    }
  }
  .respectLogo {
    margin-left: 57px;
    height: 31px;
  }
  .hamburger-desktop {
    width: 20px;
    height: 10px;
    margin-left: 19px;
    cursor: pointer;
    outline: none;
  }
  .close-desktop {
    width: 12px;
    height: 12px;
    margin-left: 19px;
    cursor: pointer;
    outline: none;
  }
  .desktopMenu {
    height: calc(100vh - 80px);
    background-image: url("~@/assets/images/bg/menu-bg.jpg");
    background-repeat: no-repeat;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    background-position: center;
    position: fixed;
    top: 80px;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    transition: all 0.25s ease-in-out;
    visibility: hidden;
    opacity: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 100;
    padding-bottom: 35px;
    transition: all 0.2s ease-in-out;

    &.active {
      visibility: visible;
      opacity: 1;
    }

    h4,
    a {
      font-family: Poppins-Bold;
      font-size: 44.8px;
      color: #ffffff;
      letter-spacing: 0;
      line-height: 48px;
      text-transform: uppercase;
    }
    a {
      margin-bottom: 40px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .menuLink {
      font-family: Poppins-Bold;
      font-size: 44.8px;
      color: #ffffff;
      letter-spacing: 0;
      line-height: 48px;
      text-transform: uppercase;
      padding-bottom: 10px;
      cursor: pointer;
      border-bottom: 4px solid transparent;
      transition: border-bottom 0.3s ease-in-out;
      &.active {
        border-bottom: 4px solid #eaeaea;
      }
    }
    .previousCollection {
      padding-left: 40px;
      margin-top: 30px;
      height: fit-content;
      max-height: 0;
      overflow: hidden;
      transition: max-height 0.3s ease-in-out;
      &.active {
        max-height: 500px;
        transition: max-height 0.3s ease-in-out;
      }
      h4,
      a {
        color: #ffffff;
        font-family: Poppins-Bold;
        font-size: 24px;
        letter-spacing: 0;
        line-height: 48px;
      }
    }
    .desktopMenuContainer {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding-bottom: 6%;
    }
  }
}
</style>

<style lang="scss">
#artists {
  a {
    color: $red;
    text-decoration: none;
  }
}
</style>